<template>
  <v-row class="add-client-form no-padding row-height">
    <successModal
      ref="success_modal"
      v-on:confirm="closeSuccessModal"
    ></successModal>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <h3 class="form-title font col-md-12">Account Settings</h3>
        </div>
      </div>
      <div class="col-md-12 text-center justify-center" v-if="readyToShow">
        <v-progress-circular
          indeterminate
          :size="100"
          color="primary"
          class="text-center"
        ></v-progress-circular>
      </div>
      <v-form v-model.trim="valid" ref="form" class="row" v-else>
        <div class="col-md-6">
          <div class="col-md-12 pb-0">
            <label class="font text-gray" for="">Account Type</label>
            <v-select
              :items="typeOptions"
              required
              v-model.trim="accountType"
              solo
            ></v-select>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for="">Company Legal Name</label>
            <v-text-field
              required
              :rules="requiredRules"
              v-model.trim="companyName"
              solo
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for="">Company Display Name</label>
            <v-text-field
              required
              :rules="requiredRules"
              v-model.trim="displayName"
              solo
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for="">Tax ID</label>
            <v-text-field
              required
              v-model.trim="taxId"
              @keyup="showSlash($event)"
              solo
              placeholder="00-0000000"
              :rules="taxIdRules"
              counter="10"
              maxlength="10"
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for="">Website </label>
            <v-text-field required v-model.trim="website" solo></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for=""
              >Company Logo (Image Size - Width = 100px Height = 50px)</label
            >
            <div class="row mt-1">
              <div class="col-xl-10 col-md-9 col-xs-12 col-sm-12" cols="12">
                <v-file-input
                  @change="Preview_image"
                  v-model.trim="dataComponents.image"
                  required
                  solo
                  truncate-length="15"
                  ref="fileInput"
                ></v-file-input>
              </div>
              <div
                v-if="$role != 'user'"
                class="col-xl-2 col-md-3 col-xs-12 col-sm-12"
                cols="12"
              >
                <v-btn
                  class="blue-buttons col-sm-12"
                  @click="activateFileInput"
                  style="padding: 23px"
                >
                  Browse
                </v-btn>
              </div>
            </div>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for=""
              >Profile Picture (Image Size - Width = 100px Height = 50px)</label
            >
            <div class="row mt-1">
              <div class="col-xl-10 col-md-9 col-xs-12 col-sm-12" cols="12">
                <v-file-input
                  @change="Preview_profileImage"
                  v-model.trim="dataComponents.profileImage"
                  required
                  solo
                  truncate-length="15"
                  ref="profileInput"
                ></v-file-input>
              </div>
              <div
                v-if="$role != 'user'"
                class="col-xl-2 col-md-3 col-xs-12 col-sm-12"
                cols="12"
              >
                <v-btn
                  class="blue-buttons col-sm-12"
                  @click="activateProfileInput"
                  style="padding: 23px"
                >
                  Browse
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="col-md-12 pb-0">
            <label class="font text-gray" for="">HQ Address Line 1</label>
            <v-text-field required v-model.trim="address1" solo></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for="">HQ Address Line 2</label>
            <v-text-field required v-model.trim="address2" solo></v-text-field>
          </div>
          <v-row class="no-padding">
            <div class="col-md-6 pb-0 pt-0">
              <label class="font text-gray" for="">City </label>
              <v-text-field required v-model.trim="city" solo></v-text-field>
            </div>
            <div class="col-md-3 pb-0 pt-0">
              <label class="font text-gray" for="">State</label>
              <v-select
                :items="states"
                item-text="name"
                item-value="name"
                required
                v-model.trim="state"
                solo
              ></v-select>
            </div>
            <div class="col-md-3 zip-field-height pb-0 pt-0">
              <label class="font text-gray" for="">Zip</label>
              <v-text-field
                :rules="zip.length > 0 ? zipRules : []"
                type="number"
                v-model.trim="zip"
                solo
              ></v-text-field>
            </div>

            <div class="col-lg-10 col-md-12 mt-3">
              <v-btn
                large
                @click="generatePdf"
                class="blue-buttons blue-buttons-font-size"
                >Access the Apaly Health Terms of Use Agreement</v-btn
              >
            </div>
          </v-row>
        </div>
        <div class="col-md-12 d-flex align-end flex-column">
          <v-btn class="blue-buttons" v-if="$role != 'user'" @click="update">
            Update & Save
          </v-btn>
        </div>
      </v-form>
    </div>
  </v-row>
</template>
<script>
import api from "../../../../services/api";
import successModal from "../../../TablesTemplate/SuccessDialog.vue";

export default {
  components: { successModal },
  data() {
    return {
      companyName: "",
      displayName: "",
      taxId: "",
      website: "",
      logo: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      accountType: "",
      typeItems: [],
      dataComponents: {
        image: {
          name: "",
        },
        profileImage: {
          name: "",
        },
      },
      typeOptions: [
        {
          text: "TPA",
          value: "TPA",
        },
        {
          text: "Broker Consultant",
          value: "brokerConsultant",
        },
        {
          text: "Analytics Consultant",
          value: "analyticsConsultant",
        },
      ],
      logoChange: false,
      profileChange: false,
      numberOfEmp: "",
      numberOfMembers: "",
      vendor: "",
      states: [],
      discountRate: "",
      valid: false,
      requiredRules: [(v) => !!v || "This field is required"],
      imageEvent: null,
      imageProfleEvent: null,
      readyToShow: false,
      taxIdRules: [
        (v) => !!v || "This field is required",
        (v) =>
          !!/[0-9]{2}\-[0-9]{7}/.test(v) ||
          "Tax ID should contain 9 digits, Please enter your Tax ID in XX-XXXXXXX format",
      ],
      zipRules: [
        (v) => (v && v.length == 5) || " Zip Code should be five digits long",
      ],
    };
  },
  computed: {
    singleEmp() {
      let provider = "";
      if (localStorage.getItem("employer")) {
        provider = JSON.parse(localStorage.getItem("employer"));
      }

      return provider;
    },
  },
  created() {
    this.getStates();
    this.getInfo();
  },
  methods: {
    generatePdf() {
      window.open("https://api.apaly.net/terms");
    },
    showSlash(event) {
      if (this.taxId.length == 2 && event.keyCode != 8) {
        this.taxId += "-";
      }
      if (this.taxId.length == 2 && event.keyCode != 8) {
        this.taxId += "-";
      }
      if (this.taxId.length == 10) {
        api()
          .get("auth/isValidTaxId?taxId=" + this.taxId)
          .catch((res) => {
            if (res) {
              this.taxIdRules = [res.response.data.message];
            }
          });
      } else {
        this.taxIdRules = [
          (v) => !!v || "This field is required",
          (v) =>
            !!/[0-9]{2}\-[0-9]{7}/.test(v) ||
            "Tax ID should contain 9 digits, Please enter your Tax ID in XX-XXXXXXX format",
        ];
      }
    },
    activateFileInput() {
      this.$refs.fileInput.$refs.input.click();
    },
    activateProfileInput() {
      this.$refs.profileInput.$refs.input.click();
    },
    getStates() {
      api()
        .get("/api/states")
        .then((res) => {
          res.data.forEach((el) => {
            if (el.active) {
              this.states.push(el);
            }
          });
        });
    },
    getInfo() {
      this.readyToShow = true;
      let user = JSON.parse(localStorage.getItem("user"));
      let advisorId = user.groupPortal[0].organization.employerAdvisor;
      api()
        .get(`/advisors/${advisorId}`)
        .then((res) => {
          if (res) {
            this.companyName = res.data.advisor.companyName;
            this.displayName = res.data.advisor.displayName
              ? res.data.advisor.displayName
              : "";
            this.taxId = res.data.advisor.taxId;
            this.address1 = res.data.advisor.address1
              ? res.data.advisor.address1
              : "";
            this.address2 = res.data.advisor.address2
              ? res.data.advisor.address2
              : "";
            this.website = res.data.advisor.website
              ? res.data.advisor.website
              : "";
            this.city = res.data.advisor.city ? res.data.advisor.city : "";
            this.state = res.data.advisor.state ? res.data.advisor.state : "";
            this.zip = res.data.advisor.zipCode ? res.data.advisor.zipCode : "";
            this.accountType = res.data.advisor.advisorType
              ? res.data.advisor.advisorType
              : "";
            this.dataComponents.image.name = res.data.advisor.logo
              ? res.data.advisor.logo
              : "";
            this.dataComponents.profileImage.name = res.data.advisor
              .primaryContact.profile
              ? res.data.advisor.primaryContact.profile
              : "";
            this.readyToShow = false;
          }
        });
    },
    closeSuccessModal() {
      this.$refs.success_modal.closePopUp();
    },
    update() {
      this.$refs.form.validate();
      if (this.valid) {
        let data = {
          companyName: this.companyName,
          displayName: this.displayName,
          address1: this.address1,
          address2: this.address2,
          website: this.website,
          city: this.city,
          state: this.state,
          zipCode: this.zip,
          taxId: this.taxId,
          advisorType: this.accountType,
        };

        let user = JSON.parse(localStorage.getItem("user"));
        let advisorId = user.groupPortal[0].organization.employerAdvisor;

        api()
          .put(`/advisors/${advisorId}`, data)
          .then((res) => {
            if (res) {
              if (this.profileChange) {
                if (this.imageProfleEvent) {
                  let formData = new FormData();
                  formData.append("_method", "PUT");
                  formData.append("image", this.imageProfleEvent);
                  api()
                    .put(`/advisors/${advisorId}/profile`, formData)
                    .then((res) => {
                      document.getElementById("profile-img").click();
                    });
                } else {
                  api()
                    .delete(`/advisors/${advisorId}/profile`)
                    .then((res) => {
                      document.getElementById("profile-img").click();
                    });
                }
              }
              if (this.logoChange) {
                if (this.imageEvent) {
                  let formData = new FormData();
                  formData.append("_method", "PUT");
                  formData.append("image", this.imageEvent);
                  api()
                    .put(`/advisors/${advisorId}/logo`, formData)
                    .then((res) => {
                      document.getElementById("logo-img").click();
                    });
                } else {
                  api()
                    .delete(`/advisors/${advisorId}/logo`)
                    .then((res) => {
                      document.getElementById("logo-img").click();
                    });
                }
              }

              this.$refs.success_modal.openPopUp(
                "Account updated successfully"
              );
              document.getElementById("changeDisplayName").click();
              this.logoChange = false;
              this.profileChange = false;
            }
          });
      }
    },
    Preview_image(event) {
      this.logoChange = true;
      this.imageEvent = event;
    },
    Preview_profileImage(event) {
      this.profileChange = true;
      this.imageProfleEvent = event;
    },
  },
};
</script>
<style>
.zip-field-height {
  height: 100px;
}
</style>